// extracted by mini-css-extract-plugin
module.exports = {"toggleOn":"SaveButton_toggleOn__11B1a","slots":"SaveButton_slots__1QEV8"};